var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logo-header",
    viewBox: "0 0 106 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M9.169 25.461c-1.466 0-2.694-.348-3.687-1.043s-1.739-1.642-2.24-2.838c-.501-1.206-.751-2.555-.751-4.049 0-1.512.25-2.866.751-4.063s1.234-2.138 2.198-2.824c.974-.696 2.175-1.043 3.603-1.043 1.419 0 2.648.348 3.687 1.043 1.048.686 1.86 1.628 2.435 2.824.575 1.187.863 2.542.863 4.063 0 1.503-.283 2.852-.849 4.049s-1.363 2.143-2.393 2.838c-1.03.696-2.235 1.043-3.617 1.043zM1.92 31.722V10.018h2.963v10.546H5.3v11.158H1.919zm6.734-9.266c.872 0 1.591-.218 2.157-.654s.983-1.025 1.252-1.767c.278-.751.417-1.586.417-2.504 0-.909-.139-1.735-.417-2.477-.278-.751-.71-1.345-1.294-1.781-.584-.445-1.326-.668-2.226-.668-.853 0-1.549.209-2.087.626-.538.408-.937.983-1.197 1.725-.25.733-.376 1.591-.376 2.574 0 .974.125 1.832.376 2.574.26.742.663 1.322 1.21 1.739.557.408 1.285.612 2.184.612zm16.159 3.005c-1.521 0-2.857-.329-4.007-.988s-2.05-1.572-2.699-2.741c-.64-1.169-.96-2.514-.96-4.035 0-1.642.315-3.065.946-4.271.631-1.215 1.507-2.157 2.63-2.824S23.144 9.6 24.619 9.6c1.558 0 2.88.366 3.965 1.099 1.095.723 1.906 1.748 2.435 3.075s.728 2.889.598 4.689h-3.325v-1.224c-.009-1.632-.297-2.824-.863-3.576s-1.456-1.127-2.671-1.127c-1.373 0-2.393.427-3.061 1.28-.668.844-1.002 2.082-1.002 3.715 0 1.521.334 2.699 1.002 3.534s1.642 1.252 2.922 1.252c.826 0 1.535-.181 2.129-.543.603-.371 1.067-.904 1.391-1.6l3.311 1.002c-.575 1.354-1.465 2.407-2.671 3.158a7.31 7.31 0 0 1-3.965 1.127zm-5.176-6.998v-2.532h10.337v2.532H19.637zm22.778 6.58c-.993.185-1.966.264-2.922.237-.946-.018-1.795-.19-2.546-.515a3.528 3.528 0 0 1-1.711-1.572c-.343-.649-.524-1.312-.543-1.99s-.028-1.442-.028-2.296V5.843h3.339v12.87c0 .603.005 1.132.014 1.586.019.455.116.825.292 1.113.334.557.867.867 1.6.932s1.567.028 2.504-.111v2.81zM31.938 12.647v-2.63h10.477v2.63H31.938zm12.873 12.396V4.591h3.353v20.452h-3.353z",
    style: {
      fill: "var(--color1, #262626)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6b83d",
    d: "M63.297 9.762c-1.892-2.233-5.046-2.834-7.416-.789s-2.704 5.464-.842 7.883c1.192 1.549 4.245 4.422 6.286 6.287.678.62 1.017.93 1.424 1.054.349.107.748.107 1.097 0 .406-.124.745-.434 1.424-1.054 2.041-1.865 5.094-4.738 6.286-6.287 1.861-2.419 1.568-5.86-.842-7.883s-5.524-1.444-7.416.789z",
    style: {
      fill: "var(--color2, #f6b83d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "m81.141 25.043-5.454-15.026h3.353l3.784 10.894 3.77-10.894h3.367l-5.454 15.026H81.14zm16.493.418c-1.521 0-2.857-.329-4.007-.988s-2.05-1.572-2.699-2.741c-.64-1.169-.96-2.514-.96-4.035 0-1.642.315-3.065.946-4.271.631-1.215 1.507-2.157 2.63-2.824S95.965 9.6 97.44 9.6c1.558 0 2.88.366 3.965 1.099 1.094.723 1.906 1.748 2.435 3.075s.728 2.889.598 4.689h-3.325v-1.224c-.009-1.632-.297-2.824-.863-3.576s-1.456-1.127-2.671-1.127c-1.373 0-2.393.427-3.061 1.28-.668.844-1.002 2.082-1.002 3.715 0 1.521.334 2.699 1.002 3.534s1.642 1.252 2.922 1.252c.825 0 1.535-.181 2.129-.543.603-.371 1.067-.904 1.391-1.6l3.311 1.002c-.575 1.354-1.466 2.407-2.671 3.158a7.31 7.31 0 0 1-3.965 1.127zm-5.176-6.998v-2.532h10.337v2.532H92.458z",
    style: {
      fill: "var(--color1, #262626)"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logo-main",
    viewBox: "0 0 109 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.414 25.571c-1.505 0-2.767-.357-3.786-1.071s-1.786-1.686-2.3-2.914c-.514-1.238-.771-2.624-.771-4.157 0-1.552.257-2.943.771-4.171s1.267-2.195 2.257-2.9c1-.714 2.233-1.071 3.7-1.071 1.457 0 2.719.357 3.786 1.071 1.076.705 1.91 1.671 2.5 2.9.59 1.219.886 2.61.886 4.171 0 1.543-.29 2.929-.871 4.157s-1.4 2.2-2.457 2.914-2.295 1.071-3.714 1.071zM1.971 32V9.714h3.043v10.829h.429V32H1.972zm6.915-9.514c.895 0 1.633-.224 2.214-.671s1.01-1.052 1.286-1.814c.286-.771.429-1.629.429-2.571 0-.933-.143-1.781-.429-2.543-.286-.771-.729-1.381-1.329-1.829-.6-.457-1.362-.686-2.286-.686-.876 0-1.59.214-2.143.643-.552.419-.962 1.01-1.229 1.771-.257.752-.386 1.633-.386 2.643 0 1 .129 1.881.386 2.643.267.762.681 1.357 1.243 1.786.571.419 1.319.629 2.243.629zm16.591 3.085c-1.562 0-2.933-.338-4.114-1.014s-2.105-1.614-2.771-2.814c-.657-1.2-.986-2.581-.986-4.143 0-1.686.324-3.148.971-4.386.648-1.248 1.548-2.214 2.7-2.9s2.486-1.029 4-1.029c1.6 0 2.957.376 4.071 1.129 1.124.743 1.957 1.795 2.5 3.157s.748 2.967.614 4.814h-3.414v-1.257c-.009-1.676-.305-2.9-.886-3.671S26.667 12.3 25.419 12.3c-1.41 0-2.457.438-3.143 1.314-.686.867-1.029 2.138-1.029 3.814 0 1.562.343 2.771 1.029 3.629s1.686 1.286 3 1.286c.848 0 1.576-.186 2.186-.557.619-.381 1.095-.929 1.429-1.643l3.4 1.029c-.59 1.39-1.505 2.471-2.743 3.243-1.229.771-2.586 1.157-4.071 1.157zm-5.314-7.185v-2.6h10.614v2.6H20.163zm23.388 6.757c-1.019.19-2.019.271-3 .243-.971-.019-1.843-.195-2.614-.529a3.626 3.626 0 0 1-1.757-1.614c-.352-.667-.538-1.348-.557-2.043s-.029-1.481-.029-2.357V5.429h3.429v13.214c0 .619.005 1.162.014 1.629.019.467.119.848.3 1.143.343.571.89.89 1.643.957s1.609.029 2.571-.114v2.886zM32.794 12.414v-2.7h10.757v2.7H32.794zm13.217 12.729v-21h3.443v21h-3.443z",
    style: {
      fill: "var(--color3, #fff)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6b83d",
    d: "M64.565 9.369c-2.011-2.374-5.363-3.013-7.883-.839s-2.874 5.809-.896 8.38c1.267 1.647 4.512 4.701 6.682 6.684.721.659 1.082.988 1.514 1.121a2.03 2.03 0 0 0 1.166 0c.432-.132.793-.462 1.513-1.121 2.17-1.983 5.415-5.037 6.682-6.684 1.979-2.571 1.667-6.229-.895-8.38s-5.873-1.535-7.883.839z",
    style: {
      fill: "var(--color2, #f6b83d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m83.314 25.143-5.6-15.429h3.443L85.043 20.9l3.871-11.186h3.457l-5.6 15.429h-3.457zm16.935.428c-1.562 0-2.933-.338-4.114-1.014s-2.105-1.614-2.771-2.814c-.657-1.2-.986-2.581-.986-4.143 0-1.686.324-3.148.971-4.386.647-1.248 1.547-2.214 2.7-2.9s2.486-1.029 4-1.029c1.6 0 2.957.376 4.071 1.129 1.124.743 1.957 1.795 2.5 3.157s.747 2.967.614 4.814h-3.414v-1.257c-.01-1.676-.305-2.9-.886-3.671s-1.495-1.157-2.743-1.157c-1.41 0-2.457.438-3.143 1.314-.686.867-1.029 2.138-1.029 3.814 0 1.562.343 2.771 1.029 3.629s1.686 1.286 3 1.286c.847 0 1.576-.186 2.186-.557.619-.381 1.095-.929 1.429-1.643l3.4 1.029c-.59 1.39-1.505 2.471-2.743 3.243-1.229.771-2.586 1.157-4.071 1.157zm-5.315-7.185v-2.6h10.614v2.6H94.934z",
    style: {
      fill: "var(--color3, #fff)"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logo-white",
    viewBox: "0 0 106 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.169 25.461c-1.466 0-2.694-.348-3.687-1.043s-1.739-1.642-2.24-2.838c-.501-1.206-.751-2.555-.751-4.049 0-1.512.25-2.866.751-4.063s1.234-2.138 2.198-2.824c.974-.696 2.175-1.043 3.603-1.043 1.419 0 2.648.348 3.687 1.043 1.048.686 1.86 1.628 2.435 2.824.575 1.187.863 2.542.863 4.063 0 1.503-.283 2.852-.849 4.049s-1.363 2.143-2.393 2.838c-1.03.696-2.235 1.043-3.617 1.043zM1.92 31.722V10.018h2.963v10.546H5.3v11.158H1.919zm6.734-9.266c.872 0 1.591-.218 2.157-.654s.983-1.025 1.252-1.767c.278-.751.417-1.586.417-2.504 0-.909-.139-1.735-.417-2.477-.278-.751-.71-1.345-1.294-1.781-.584-.445-1.326-.668-2.226-.668-.853 0-1.549.209-2.087.626-.538.408-.937.983-1.197 1.725-.25.733-.376 1.591-.376 2.574 0 .974.125 1.832.376 2.574.26.742.663 1.322 1.21 1.739.557.408 1.285.612 2.184.612zm16.159 3.005c-1.521 0-2.857-.329-4.007-.988s-2.05-1.572-2.699-2.741c-.64-1.169-.96-2.514-.96-4.035 0-1.642.315-3.065.946-4.271.631-1.215 1.507-2.157 2.63-2.824S23.144 9.6 24.619 9.6c1.558 0 2.88.366 3.965 1.099 1.095.723 1.906 1.748 2.435 3.075s.728 2.889.598 4.689h-3.325v-1.224c-.009-1.632-.297-2.824-.863-3.576s-1.456-1.127-2.671-1.127c-1.373 0-2.393.427-3.061 1.28-.668.844-1.002 2.082-1.002 3.715 0 1.521.334 2.699 1.002 3.534s1.642 1.252 2.922 1.252c.826 0 1.535-.181 2.129-.543.603-.371 1.067-.904 1.391-1.6l3.311 1.002c-.575 1.354-1.465 2.407-2.671 3.158a7.31 7.31 0 0 1-3.965 1.127zm-5.176-6.998v-2.532h10.337v2.532H19.637zm22.778 6.58c-.993.185-1.966.264-2.922.237-.946-.018-1.795-.19-2.546-.515a3.528 3.528 0 0 1-1.711-1.572c-.343-.649-.524-1.312-.543-1.99s-.028-1.442-.028-2.296V5.843h3.339v12.87c0 .603.005 1.132.014 1.586.019.455.116.825.292 1.113.334.557.867.867 1.6.932s1.567.028 2.504-.111v2.81zM31.938 12.647v-2.63h10.477v2.63H31.938zm12.873 12.396V4.591h3.353v20.452h-3.353zM63.297 9.762c-1.892-2.233-5.046-2.834-7.416-.789s-2.704 5.464-.842 7.883c1.192 1.549 4.245 4.422 6.286 6.287.678.62 1.017.93 1.424 1.054.349.107.748.107 1.097 0 .406-.124.745-.434 1.424-1.054 2.041-1.865 5.094-4.738 6.286-6.287 1.861-2.419 1.568-5.86-.842-7.883s-5.524-1.444-7.416.789zM81.141 25.043l-5.454-15.026h3.353l3.784 10.894 3.77-10.894h3.367l-5.454 15.026H81.14zm16.493.418c-1.521 0-2.857-.329-4.007-.988s-2.05-1.572-2.699-2.741c-.64-1.169-.96-2.514-.96-4.035 0-1.642.315-3.065.946-4.271.631-1.215 1.507-2.157 2.63-2.824S95.965 9.6 97.44 9.6c1.558 0 2.88.366 3.965 1.099 1.094.723 1.906 1.748 2.435 3.075s.728 2.889.598 4.689h-3.325v-1.224c-.009-1.632-.297-2.824-.863-3.576s-1.456-1.127-2.671-1.127c-1.373 0-2.393.427-3.061 1.28-.668.844-1.002 2.082-1.002 3.715 0 1.521.334 2.699 1.002 3.534s1.642 1.252 2.922 1.252c.825 0 1.535-.181 2.129-.543.603-.371 1.067-.904 1.391-1.6l3.311 1.002c-.575 1.354-1.466 2.407-2.671 3.158a7.31 7.31 0 0 1-3.965 1.127zm-5.176-6.998v-2.532h10.337v2.532H92.458z",
    style: {
      fill: "var(--color1, #fff)"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-shape",
    viewBox: "0 0 41 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.148 7.435C-.434 2.879 3.711-.858 8.183.191L36.015 6.72a6.585 6.585 0 0 1 4.847 8.15l-3.027 11.048a29.49 29.49 0 0 0-1.048 7.794v9.07c0 4.668-4.723 7.853-9.051 6.105L4.568 39.528a6.583 6.583 0 0 1-4.105-6.513l.755-12.158c.14-2.254.067-4.516-.219-6.756L.148 7.436z",
    opacity: 0.1,
    style: {
      fill: "var(--color1, #fff)"
    }
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M24 8 8 24M8 8l16 16"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-burger-menu",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M4 16h24M4 8h24M4 24h24"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-check",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#08aa83",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.667,
    d: "M26.667 9.333 12 24l-6.667-6.667",
    style: {
      stroke: "#08aa83"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-x-red",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ef2447",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M24 8 8 24M8 8l16 16",
    style: {
      stroke: "#ef2447"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-eye",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f6b83d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.909,
    d: "M1.332 16S6.665 5.333 15.999 5.333 30.666 16 30.666 16s-5.333 10.667-14.667 10.667C6.666 26.667 1.332 16 1.332 16z",
    style: {
      stroke: "var(--color1, #f6b83d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f6b83d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.909,
    d: "M16 20a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
    style: {
      stroke: "var(--color1, #f6b83d)"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-eye-off",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f6b83d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.667,
    d: "M23.92 23.92A13.43 13.43 0 0 1 16 26.667C6.667 26.667 1.333 16 1.333 16A24.605 24.605 0 0 1 8.08 8.08m5.12-2.427a12.161 12.161 0 0 1 2.8-.32C25.333 5.333 30.667 16 30.667 16a24.646 24.646 0 0 1-2.88 4.253m-8.96-1.426a4.01 4.01 0 0 1-2.855 1.273 3.987 3.987 0 0 1-3.779-2.502 3.995 3.995 0 0 1 .983-4.424M1.333 1.333l29.333 29.333",
    style: {
      stroke: "var(--color1, #f6b83d)"
    }
  })), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-search",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.556,
    d: "M14.667 25.333c5.891 0 10.667-4.776 10.667-10.667S20.558 3.999 14.667 3.999 4 8.775 4 14.666s4.776 10.667 10.667 10.667zM28.001 28l-5.8-5.8"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-left",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.134 16.947a1.334 1.334 0 0 1 0-1.894l6.12-6.107a1.334 1.334 0 1 0-1.88-1.894l-6.12 6.12a4.001 4.001 0 0 0 0 5.654l6.12 6.12a1.337 1.337 0 0 0 2.172-.434 1.331 1.331 0 0 0-.292-1.46l-6.12-6.107z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-right",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.866 16.947a1.344 1.344 0 0 0 .395-.947 1.331 1.331 0 0 0-.395-.947l-6.12-6.107a1.334 1.334 0 1 1 1.88-1.894l6.12 6.12a4.001 4.001 0 0 1 0 5.654l-6.12 6.12a1.337 1.337 0 0 1-2.172-.434 1.331 1.331 0 0 1 .292-1.46l6.12-6.107z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-star",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc531",
    stroke: "#ffc531",
    strokeWidth: 2.4,
    d: "M12.4 9.394 16 2.572l3.6 6.822a2.2 2.2 0 0 0 1.571 1.141l7.601 1.315-5.376 5.532a2.2 2.2 0 0 0-.6 1.846l1.098 7.635-6.922-3.404a2.199 2.199 0 0 0-1.941 0l-6.922 3.404 1.098-7.635a2.2 2.2 0 0 0-.6-1.846L3.231 11.85l7.601-1.315a2.202 2.202 0 0 0 1.571-1.141zm16.635 2.185zM7.767 27.031z",
    style: {
      fill: "var(--color1, #ffc531)",
      stroke: "var(--color1, #ffc531)"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-starGray",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f4f4f4",
    stroke: "#f4f4f4",
    strokeWidth: 2.4,
    d: "M12.4 9.394 16 2.572l3.6 6.822a2.2 2.2 0 0 0 1.571 1.141l7.601 1.315-5.376 5.532a2.2 2.2 0 0 0-.6 1.846l1.098 7.635-6.922-3.404a2.199 2.199 0 0 0-1.941 0l-6.922 3.404 1.098-7.635a2.2 2.2 0 0 0-.6-1.846L3.231 11.85l7.601-1.315a2.202 2.202 0 0 0 1.571-1.141zm16.635 2.185zM7.767 27.031z",
    style: {
      fill: "var(--color1, #f4f4f4)",
      stroke: "var(--color1, #f4f4f4)"
    }
  })), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-heart",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.667,
    d: "M27.784 6.147a7.345 7.345 0 0 0-5.187-2.15 7.33 7.33 0 0 0-5.187 2.15L15.997 7.56l-1.413-1.413a7.333 7.333 0 0 0-10.374 0 7.333 7.333 0 0 0 0 10.374l11.787 11.787 11.787-11.787a7.345 7.345 0 0 0 2.15-5.187 7.33 7.33 0 0 0-2.15-5.187z"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.667,
    d: "M16 6.667v18.667M6.667 16h18.667"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-trash",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    d: "M4 8h24M25.335 8v18.667a2.668 2.668 0 0 1-2.667 2.667H9.335a2.668 2.668 0 0 1-2.667-2.667V8m4 0V5.333a2.668 2.668 0 0 1 2.667-2.667h5.333a2.67 2.67 0 0 1 2.667 2.667V8M13.332 14.667v8M18.668 14.667v8"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pencil",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.667,
    d: "M22.667 4a3.766 3.766 0 0 1 4.109-.817 3.766 3.766 0 0 1 2.04 4.926 3.766 3.766 0 0 1-.817 1.223l-18 18-7.333 2 2-7.333 18-18z"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-user",
    viewBox: "0 0 29 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.454,
    d: "M14.545 18.182c-3.843 0-7.26 1.855-9.435 4.734-.468.62-.702.93-.695 1.348.006.323.209.732.464.931.329.259.786.259 1.699.259h15.934c.913 0 1.37 0 1.699-.259.255-.2.458-.608.464-.931.008-.419-.226-.729-.695-1.348-2.175-2.879-5.593-4.734-9.435-4.734zM14.545 14.545a5.455 5.455 0 1 0 0-10.91 5.455 5.455 0 0 0 0 10.91z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-upload-cloud",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f6b83d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.311,
    d: "M16 16v12M27.187 24.52a6.671 6.671 0 0 0 3.27-7.497A6.669 6.669 0 0 0 24.001 12h-1.68a10.659 10.659 0 0 0-10.72-7.99A10.657 10.657 0 0 0 3.38 8.378a10.661 10.661 0 0 0-1.66 9.159 10.656 10.656 0 0 0 2.281 4.196",
    style: {
      stroke: "var(--color1, #f6b83d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f6b83d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.311,
    d: "M21.333 21.333 16 16l-5.333 5.333",
    style: {
      stroke: "var(--color1, #f6b83d)"
    }
  })), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-female",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    d: "M16.001 17.333a6.667 6.667 0 1 0 0-13.334 6.667 6.667 0 0 0 0 13.334zm0 0V28m-4-4h8"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-male",
    viewBox: "0 0 18 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.667,
    d: "M8.89 14.519a7.407 7.407 0 1 0 0 14.814 7.407 7.407 0 1 0 0-14.814zm0 0V2.667m0 0 5.926 5.926M8.89 2.667 2.964 8.593"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-footprint",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f6b83d",
    d: "M12.5 5c-1.07 0-2.002.608-2.594 1.438S9 8.34 9 9.5s.314 2.233.906 3.063S11.43 14 12.5 14c1.07 0 2.002-.608 2.594-1.438S16 10.66 16 9.5s-.314-2.233-.906-3.063S13.57 5 12.5 5zM16 9.5c0 1.16.314 2.233.906 3.063S18.431 14 19.5 14c1.07 0 2.002-.608 2.594-1.438S23 10.66 23 9.5s-.314-2.233-.906-3.063S20.57 5 19.5 5c-1.07 0-2.002.608-2.594 1.438S16 8.34 16 9.5zM12.5 7c.312 0 .656.156.97.594.31.437.53 1.133.53 1.906s-.22 1.47-.53 1.906c-.314.438-.658.594-.97.594s-.656-.156-.97-.594c-.31-.437-.53-1.133-.53-1.906s.22-1.47.53-1.906c.314-.438.658-.594.97-.594zm7 0c.312 0 .656.156.97.594.31.437.53 1.133.53 1.906s-.22 1.47-.53 1.906c-.314.438-.658.594-.97.594s-.656-.156-.97-.594c-.31-.437-.53-1.133-.53-1.906s.22-1.47.53-1.906c.314-.438.658-.594.97-.594zm-12 5c-1.07 0-2.002.608-2.594 1.438S4 15.34 4 16.5s.314 2.233.906 3.063S6.43 21 7.5 21c1.07 0 2.002-.608 2.594-1.438S11 17.66 11 16.5s-.314-2.233-.906-3.063S8.57 12 7.5 12zm17 0c-1.07 0-2.002.608-2.594 1.438S21 15.34 21 16.5s.314 2.233.906 3.063S23.43 21 24.5 21c1.07 0 2.002-.608 2.594-1.438S28 17.66 28 16.5s-.314-2.233-.906-3.063S25.57 12 24.5 12zm-17 2c.312 0 .656.156.97.594.31.437.53 1.133.53 1.906s-.22 1.47-.53 1.906c-.314.438-.658.594-.97.594s-.656-.156-.97-.594C6.22 17.97 6 17.273 6 16.5s.22-1.47.53-1.906c.314-.438.658-.594.97-.594zm17 0c.312 0 .656.156.97.594.31.437.53 1.133.53 1.906s-.22 1.47-.53 1.906c-.314.438-.658.594-.97.594s-.656-.156-.97-.594c-.31-.437-.53-1.133-.53-1.906s.22-1.47.53-1.906c.314-.438.658-.594.97-.594zM16 16c-1.333 0-2.263.865-2.72 1.625-.454.76-.734 1.392-1 1.656-.153.157-1.118.52-2.124 1.033-.503.257-1.01.6-1.437 1.125-.43.525-.72 1.25-.72 2.063 0 1.92 1.58 3.5 3.5 3.5.866 0 1.77-.28 2.655-.53C15.043 26.216 16 26 16 26s.957.216 1.844.47c.886.25 1.79.53 2.656.53 1.92 0 3.5-1.58 3.5-3.5 0-.794-.293-1.52-.72-2.03-.425-.513-.937-.83-1.436-1.095-1-.53-1.983-.95-2.125-1.094-.24-.237-.51-.89-.97-1.654C18.29 16.86 17.34 16 16 16zm0 2c.66 0 .733.16 1.03.656.3.495.524 1.336 1.25 2.063.825.82 1.867 1 2.626 1.404.38.202.67.417.844.625.173.207.25.396.25.75 0 .84-.66 1.5-1.5 1.5-.29 0-1.224-.22-2.094-.47-.87-.247-1.59-.53-2.406-.53s-1.536.283-2.406.53c-.87.25-1.804.47-2.094.47-.84 0-1.5-.66-1.5-1.5 0-.403.084-.61.25-.814.166-.203.472-.404.844-.593.744-.38 1.78-.53 2.625-1.375.733-.737.953-1.605 1.25-2.095.292-.49.362-.625 1.03-.625L16 18z",
    style: {
      fill: "var(--color3, #f6b83d)"
    }
  })), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-sex",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.694 10.327a4.665 4.665 0 1 0 2.913 3.635.654.654 0 0 1 .313-.672.653.653 0 0 1 .504-.078.654.654 0 0 1 .412.302.653.653 0 0 1 .089.244 5.993 5.993 0 0 1-3.514 6.403 5.998 5.998 0 1 1-.232-11.077.665.665 0 0 1 .433.609.669.669 0 0 1-.403.628.665.665 0 0 1-.515.006z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.331 26v-5.331a.665.665 0 1 1 1.332 0V26a.665.665 0 1 1-1.332 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.331 22.668a.665.665 0 0 1 .666-.666h3.998a.665.665 0 1 1 0 1.332H7.997a.665.665 0 0 1-.666-.666zm11.93-12.486a4.665 4.665 0 0 0-5.9 5.04.67.67 0 0 1-.335.663.665.665 0 0 1-.989-.506 5.997 5.997 0 1 1 3.582 4.801.673.673 0 0 1-.355-.366.668.668 0 0 1 .883-.859 4.66 4.66 0 0 0 6.243-2.723 4.667 4.667 0 0 0-3.127-6.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.855 11.477a.665.665 0 0 1 0-.942l4.998-4.998a.658.658 0 0 1 .473-.203.655.655 0 0 1 .477.196c.063.063.112.137.145.219s.05.17.05.258a.669.669 0 0 1-.203.473l-4.998 4.998a.665.665 0 0 1-.942 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.273 10.007a.669.669 0 0 1-.657-.675l.033-2.648-2.648.033a.67.67 0 0 1-.675-.658.67.67 0 0 1 .658-.675L28 5.333l-.051 4.016a.669.669 0 0 1-.675.657z"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-calendar",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.667,
    d: "M25.333 5.333H6.666A2.667 2.667 0 0 0 3.999 8v18.667a2.667 2.667 0 0 0 2.667 2.667h18.667A2.667 2.667 0 0 0 28 26.667V8a2.667 2.667 0 0 0-2.667-2.667zM21.333 2.667V8M10.667 2.667V8M4 13.333h24"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-four",
    viewBox: "0 0 23 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.815 32v-4.943H0v-5.606L10.019.221h6.886L6.886 21.451h6.93v-7.945h6.091v7.945h2.825v5.606h-2.825V32h-6.091z",
    style: {
      fill: "var(--color1, #fff)"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-shape-pc",
    viewBox: "0 0 28 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.093 6.19C-.39 2.394 3.064-.717 6.789.159L24.017 4.21a5.484 5.484 0 0 1 4.035 6.784l-2.176 7.961a11.93 11.93 0 0 0-.422 3.144v6.182c0 3.89-3.937 6.543-7.543 5.083L3.605 27.571A5.484 5.484 0 0 1 .19 22.149l.549-8.856c.056-.909.027-1.822-.088-2.725L.093 6.19z",
    opacity: 0.1,
    style: {
      fill: "var(--color1, #fff)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.29246e8f1121cd2d319192118873ca5e.svg";
export { ForwardRef as ReactComponent };